import React,{useState,useEffect} from 'react'
import '../Media.css'
import axios from 'axios'
import Pagination from '@mui/lab/Pagination'
import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'
import photol from '../../../assets/Photo'



const Photo=()=> {
 
  const[imgs,setImg]=useState([])
  const [page,setPage]=useState(1)
  // const[curindex,setcurIndex]=useState()
  const loadPhoto =async()=>{
    const res=await axios.get(`https://jsonplaceholder.typicode.com/photos?_page=${page}`)
    setImg(res.data)
  }
 useEffect(()=>{
   loadPhoto()
 })
    
    return (
      <>
      <Gallery>
      <div className='PhotoSection'>
          <div className='photos'>
           {
              
             photol.map((item,index)=>{
               return(
               
                <Item key={index}
                original={item.imgurl}
                thumbnail=""
                width="700 "
                height="500"
              >
                {({ ref, open }) => (
                  <div  className='photo'>
                  <img src= {item.imgurl} ref={ref} onClick={open} alt="Images" 
                  
          />
                  
                 </div>
                )}
              </Item>
            
                )
               })
           }
        </div>
        
        
    
    </div>
    </Gallery>
   <div className='pagination'>
       
        <Pagination count={23} 
        color={"primary"}
        defaultPage={page}
        siblingCount={0}
        boundaryCount={2}
        onChange={(event,value)=>setPage(value)}
        size="large"
        />
       </div>
    </>
  )
}

export default Photo